import { baseApi } from '../utils/api'

export const isLogin = (data) => {
  return baseApi({
    url: '/sysuser/login',
    method: 'post',
    data
  })
}
